import { ApiPostRequest } from './api-post-request';
import { ApiParameters } from './api-parameters';

export class ErrorLogRequest extends ApiPostRequest
{
    public constructor(category: string, message: string, stack: string, userAgent: string, webapiBasepath: string) 
    {
        super(  'log/error', 
                new ApiParameters(), 
                null, 
                { 'category': category, 'message': message, 'stack': stack, 'userAgent': userAgent }, 
                webapiBasepath
            );
    }
}
